import RackMacro from './RackMacro.js';

export default superclass => class extends superclass  {
    macros = [];

    connectNodeToMacro(node, macro) {
        if (node && node.isParameter) {
            macro.addParameter(node);
        }
    }

    isMacro(node) {
        return this.macros.indexOf(node) > -1;
    }

    deleteMacro(macro) {
        let index = this.macros.indexOf(macro);
        this.macros.splice(index, 1);
        macro.dispose();
    }

    newMacro(context=this.context) {
        let name = "Macro " + (this.macros.length + 1);
        let macro = new RackMacro(name, this.sequencerEngine, context);
        this.macros.push(macro);
        return macro;
    }

    get macroAdjacencyLists() {
        let adjLists = {};
        for (let i in this.macros) {
            let macro = this.macros[i];
            let {subMacros} = macro;
            adjLists[macro.id] = subMacros;
        }
        return adjLists;
    }
};
